import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './DiscountBanner.css';

const DISCOUNT_KEY  = 'first_month_discount_active';
const DISMISSED_KEY = 'discount_banner_dismissed';
const SHOW_DELAY_MS = 15000;

const DiscountBanner = () => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    // Only show on the homepage
    if (pathname !== '/') return;
    // Never show to logged-in users
    if (localStorage.getItem('access_token')) return;
    // Don't show again if dismissed earlier in this session
    if (sessionStorage.getItem(DISMISSED_KEY)) return;
    // Already active this session (user navigated between pages) — show immediately
    if (sessionStorage.getItem(DISCOUNT_KEY)) {
      setVisible(true);
      return;
    }
    const timer = setTimeout(() => {
      sessionStorage.setItem(DISCOUNT_KEY, 'true');
      setVisible(true);
    }, SHOW_DELAY_MS);
    return () => clearTimeout(timer);
  }, [pathname]);

  // Hide immediately if the user logs in while the banner is showing
  useEffect(() => {
    if (!visible) return;
    const id = setInterval(() => {
      if (localStorage.getItem('access_token')) setVisible(false);
    }, 500);
    return () => clearInterval(id);
  }, [visible]);

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISSED_KEY, 'true');
    setVisible(false);
  };

  if (!visible || pathname !== '/') return null;

  return (
    <div className="discount-banner" role="status" aria-live="polite">
      <span className="discount-banner__text">
        Your first month is half price — no code needed, already reflected at checkout.
      </span>
      <button
        type="button"
        className="discount-banner__close"
        onClick={handleDismiss}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};

export default DiscountBanner;
